
import { armpitPainArticle } from "./articles/pain";
import { armpitPainLymphNodesArticle } from "./articles/lymph-nodes";
import { armpitHealthBasicsArticle } from "./articles/health";
import { armpitCystsArticle } from "./articles/cysts";
import { underarmRashArticle } from "./articles-rash";
import { deodorantGuideArticle } from "./articles-deodorant";
import { shavingArmpisArticle } from "./articles-shaving";
import { armpitTreatmentsArticle } from "./articles-treatments";
import { armpitHairArticle } from "./articles-hair";
import { armpitRashItchyArticle } from "./articles/rash-itchy";

// Articles collection for the blog
export const articles = {
  "understanding-armpit-pain": armpitPainArticle,
  "armpit-pain-lymph-nodes-swelling-causes": armpitPainLymphNodesArticle,
  "armpit-health-basics": armpitHealthBasicsArticle,
  "understanding-armpit-cysts": armpitCystsArticle,
  "effective-remedies-underarm-rash": underarmRashArticle,
  "the-ultimate-deodorant-guide": deodorantGuideArticle,
  "how-to-shave-armpits-properly": shavingArmpisArticle,
  "advanced-armpit-treatments-glycolic-acid-botox": armpitTreatmentsArticle,
  "armpit-hair-care-removal-options": armpitHairArticle,
  "armpit-rash-itchy-causes-treatments": armpitRashItchyArticle
};

// Create an articlesArray for the Blog component
export const articlesArray = Object.values(articles);
